export default __webpack_public_path__ + "25910a9490256e66f2d712e6a72c17ba.png";